// extracted by mini-css-extract-plugin
export default {"slugHeading":"slugHeading__57Cy3","link":"link__5i8EJ","icon":"icon__hQT+d"};